import { StyleSheet } from 'react-native'
import { pageContainerStyle } from '../../common.style'

export default StyleSheet.create({
   container: {
    ...pageContainerStyle,
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingVertical: 20,
  },

  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
   // flex: 1,
  },
  tuile: {
      minHeight: 120,
      borderRadius: 12,
      margin: '1%',
      padding: '1%',
      justifyContent: 'space-evenly',
      width: '48%'  ,
      backgroundColor: '#d4def3'
  },
  texteURL: {
    fontSize: 16,
    color: '#3b82f6',
    marginTop: 5,
  },
  texteTuile:{
    fontSize: 14,
    color: 'black',
    marginTop: '1%'
  },
  lottieContainer: {
    alignItems: 'center',
    zIndex: -1,
    flex: 1,
    height: '100%',
    justifyContent: 'flex-start',
  },
    lottie: {
    height: 200,
    width: 250,
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',

  },

  menuText: {
    flex: 1,
  },
  menuTitle: {
    fontSize: 15,
    fontWeight: '600',
    color: '#151A2D',
  },
  menuSubtitle: {
    marginTop: 2,
    fontSize: 12,
    color: '#8A90A6',
  },

  menuCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    paddingVertical: 14,
    paddingHorizontal: 14,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 1,
  },
})
